<template>
    <div>
        <SearchableSelect
            :value="value"
            :title="title"
            :disabled="disabled"
            :search-enabled="searchEnabled"
            :tooltip="tooltip"
            :options="options"
            :bg-color="bgColor"
            :text-color="textColor"
            :border-color="borderColor"
            :border-radius="borderRadius"
            @input="select"
        />
    </div>
</template>

<script>
import SearchableSelect from "./SearchableSelect.vue";

export default {
    components: {
        SearchableSelect,
    },
    props: {
        label: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "",
        },
        tooltip: {
            type: String,
            default: "",
        },
        options: {
            type: Array,
            default: () => [],
        },
        value: {
            type: [String, Number],
            default: "",
        },
        help: {
            type: String,
            default: "",
        },
        warning: {
            type: String,
            default: "",
        },
        success: {
            type: String,
            default: "",
        },
        error: {
            type: String,
            default: "",
        },
        disabled: Boolean,
        transparent: Boolean,
        searchEnabled: {
            type: Boolean,
            default: true,
        },
        modelValue: {
            type: [String, Number],
            default: "",
        },
        bgColor: {
            type: String,
            default: "",
        },
        textColor: {
            type: String,
            default: "",
        },
        borderColor: {
            type: String,
            default: "",
        },
        borderRadius: {
            type: String,
            default: "",
        },
    },
    emits: ["update:modelValue", "input", "change"],
    methods: {
        select(value) {
            this.$emit("input", value);
            this.$emit("change", value);
            this.$emit("update:modelValue", value);
        },
    },
};
</script>
